import React, { useEffect, useState } from "react";
import { Eye, EyeOff, HelpCircle, Globe } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import styles from "../../styles/__login.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import InsuranceLoginImg from "../../assets/images/insuranceLogin.png";
import { postInsuranceLogin } from "../../reducer/insuranceLogin/insuranceLoginReducer";
import CountryCodeSelect from "../../components/country-code-select/CountryCodeSelect";
import {
  DEFAULT_COUNTRY_ISO,
  findCountryByIso,
} from "../../constants/countries";
import {
  getMobileLengthIssue,
  limitMobileDigits,
  mobileLengthErrorText,
} from "../../utils/phoneValidation";
const InsuranceLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);
  const [selectedRole, setSelectedRole] = useState("Doctor");
  const [countryIso, setCountryIso] = useState(DEFAULT_COUNTRY_ISO);
  const [name, setName] = useState("hussan");
  const [mobileNumber, setMobileNumber] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});

  // Same country list (with search and flags) as every other mobile number field in the app.
  const selectedCountryData = findCountryByIso(countryIso);
  // Digit count required for the selected country (libphonenumber-js metadata).
  const mobileLengthIssue = getMobileLengthIssue(mobileNumber, countryIso);
  const mobileLengthError = mobileLengthIssue
    ? mobileLengthErrorText(t, i18n.language, selectedCountryData, mobileLengthIssue)
    : "";
  // The error from the last sign-in attempt, or "too long" at once (e.g. after switching country).
  const mobileError =
    errors.mobileNumber || (mobileLengthIssue?.tooLong ? mobileLengthError : "");
  const clearMobileError = () =>
    setErrors((prev) =>
      prev.mobileNumber ? { ...prev, mobileNumber: undefined } : prev,
    );

  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) {
      newErrors.name = "Name is required";
    }
    // Mobile validation
    if (!mobileNumber.trim()) {
      newErrors.mobileNumber = "Mobile number is required";
    } else if (mobileLengthIssue) {
      newErrors.mobileNumber = mobileLengthError;
    }

    // Password validation
    if (!password.trim()) {
      newErrors.password = "Password is required";
    } else if (password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    } else if (!/[a-z]/.test(password)) {
      newErrors.password =
        "Password must include at least one lowercase letter";
    } else if (!/[A-Z]/.test(password)) {
      newErrors.password =
        "Password must include at least one uppercase letter";
    } else if (!/[0-9]/.test(password)) {
      newErrors.password = "Password must include at least one number";
    } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      newErrors.password =
        "Password must include at least one special character";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const passwordRules = {
    length: {
      test: (pwd) => pwd.length >= 8,
      message: "At least 8 characters",
    },
    lowercase: {
      test: (pwd) => /[a-z]/.test(pwd),
      message: "At least one lowercase letter",
    },
    uppercase: {
      test: (pwd) => /[A-Z]/.test(pwd),
      message: "At least one uppercase letter",
    },
    number: {
      test: (pwd) => /[0-9]/.test(pwd),
      message: "At least one number",
    },
    special: {
      test: (pwd) => /[!@#$%^&*(),.?\":{}|<>]/.test(pwd),
      message: "At least one special character",
    },
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // navigate("/i_dashboard")
    if (!validateForm()) return;
    console.log("Login attempt:", {
      selectedRole,
      countryCode: selectedCountryData.code,
      mobileNumber,
      password,
    });
    const roleId = 6;
    const loginData = {
      role_id: roleId,
      mobile_number: `${selectedCountryData.code}${mobileNumber}`,
      password: password,
    };

    const result = await dispatch(postInsuranceLogin(loginData));
    //  console.log('result:', result);
    if (result && result.payload) {
      // Save tokens
      sessionStorage.setItem("usr_1a2b3c", result.payload.data.access_token);
      sessionStorage.setItem("usr_4d5e6f", result.payload.data.refresh_token);

      // Store consultation_type if available
      if (result.payload.data.user?.consultation_type) {
        sessionStorage.setItem(
          "usr_consultation_type",
          result.payload.data.user.consultation_type,
        );
      }

      // Navigate after login
      if (
        result.payload.data.access_token &&
        result.payload.data.refresh_token
      ) {
        navigate("/i_dashboard");
      }
      // if(result.payload.data.data.verification_status === "NOT_UPLOADED" && result.payload.data.data.user.role_id === 4 ){
      //   navigate("/upload-documents");
      // }
      // else if(result.payload.data.data.verification_status === "APPROVED" && result.payload.data.data.user.role_id === 4){
      //   navigate("/dashboard")
      // }
      // else if(result.payload.data.data.verification_status === "REJECTED" && result.payload.data.data.user.role_id === 4){
      //   navigate("/upload-required-documents")
      // }
      // else if(result.payload.data.data.verification_status === "PENDING" && result.payload.data.data.user.role_id === 4){
      //   navigate("/documents-under-process")
      // }
      // else if(result.payload.data.data.verification_status === "NOT_UPLOADED" && result.payload.data.data.user.role_id === 5){
      //   navigate("/pharmacy-upload-documents")
      // }
      // else if(result.payload.data.data.verification_status === "APPROVED" && result.payload.data.data.user.role_id === 5){
      //   navigate("/pharmacy-dashboard")
      // }
      // else if(result.payload.data.data.verification_status === "REJECTED" && result.payload.data.data.user.role_id === 5){
      //   navigate("/upload-required-documents")
      // }
      // else if(result.payload.data.data.verification_status === "PENDING" && result.payload.data.data.user.role_id === 5){
      //   navigate("/documents-under-process")
      // }
    }
  };

  return (
    <div className={styles["main-container"]}>
      {/* Main Content */}
      <main className={styles["main-content"]}>
        <div className={styles["content-wrapper"]}>
          {/* Doctor Illustration */}
          <div className={styles["illustration"]}>
            <div className={styles["doctor-illustration"]}>
              <img
                src={InsuranceLoginImg}
                alt="Insurance help"
                className={styles["doctor-image"]}
              />
            </div>
          </div>

          {/* Login Form */}
          <div className={styles["login-form-container"]}>
            <h2>{t("loginToAccount")}</h2>
            <form onSubmit={handleSubmit} className={styles["login-form"]}>
              {/* Role Selection */}
              <div className={styles["form-group"]}>
                <label htmlFor={styles["role"]}>Insurance Name</label>
                <input
                  type="text"
                  id="insuranceName"
                  placeholder="GlobeMed"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className={styles["form-input"]}
                />
              </div>
              {errors.name && (
                <p className={styles["rule-invalid"]}>{errors.name}</p>
              )}
              {/* Mobile Number */}
              <div className={styles["form-group"]}>
                <label htmlFor="mobile">Mobile Number</label>
                <div className={styles["mobile-input-container"]}>
                  <CountryCodeSelect
                    className={styles["country-selector"]}
                    value={countryIso}
                    onChange={(country) => {
                      setCountryIso(country.iso);
                      clearMobileError();
                    }}
                  />
                  <input
                    type="tel"
                    id="mobile"
                    placeholder="770 123 4567"
                    inputMode="numeric"
                    value={mobileNumber}
                    onChange={(e) => {
                      // Digits only, no leading 0, and no more digits than the
                      // selected country's mobile numbers have.
                      setMobileNumber(limitMobileDigits(e.target.value, countryIso));
                      clearMobileError();
                    }}
                    aria-invalid={!!mobileError || undefined}
                    aria-describedby={mobileError ? "mobile-error" : undefined}
                    className={styles["phone-input"]}
                  />
                </div>
                {mobileError && (
                  <p id="mobile-error" role="alert" className={styles["rule-invalid"]}>
                    {mobileError}
                  </p>
                )}
              </div>
              {/* Password */}
              <div className={styles["form-group"]}>
                <label htmlFor="password">{t("password")}</label>
                <div className={styles["password-wrapper"]}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder="••••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className={styles["form-input"]}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className={styles["password-toggle"]}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
                <div className={styles["password-rules"]}>
                  {Object.keys(passwordRules).map((ruleKey) => {
                    const rule = passwordRules[ruleKey];
                    const isValid = rule.test(password);
                    return (
                      <p
                        key={ruleKey}
                        className={
                          isValid
                            ? styles["rule-valid"]
                            : styles["rule-invalid"]
                        }
                      >
                        {isValid ? "✔" : "✖"} {rule.message}
                      </p>
                    );
                  })}
                </div>
                {/* <p className={styles["Forgot-pwd-link"]}><Link to="/forgot-password">{t("forgotPassword")}?</Link></p> */}
              </div>

              {/* Login Button */}
              <button type="submit" className={styles["login-btn"]}>
                {t("login")}
              </button>
            </form>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default InsuranceLogin;
